import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { QUERY_PAYMENTS_TAXFORM_WITH_CORRECTION_PAYER } from "../keys";
import { paymentsService } from "../../../services/payments";
import { WSServiceError } from "../../../utils/serviceHelper";
import { IPayerTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";

export const usePayerTaxFormWithCorrection = (
  taxFormId: string,
  queryConfig?: WSQueryConfig<IPayerTaxFormResponse, WSServiceError>
) =>
  useWSQuery<IPayerTaxFormResponse, WSServiceError>(
    [QUERY_PAYMENTS_TAXFORM_WITH_CORRECTION_PAYER, taxFormId],
    () => paymentsService.taxForm.get(taxFormId),
    queryConfig
  );
